import axios from "axios";

import { newAxiosInstance } from "./newAxiosInstance";

export function getUniversalAxios() {
  if (import.meta.client) {
    return axios;
  }

  if (!globalThis.serverAxios) {
    globalThis.serverAxios = newAxiosInstance();
  }

  return globalThis.serverAxios;
}
